/** Namespace `subscriptions` — bản gốc tiếng Việt. Khoá phẳng, tên camelCase; `{biến}` để chèn. */
export const subscriptions = {
  title: "Gói đăng ký",
  subtitle: "Ảnh chụp mới nhất theo bậc gói — số dư, không phải tổng cộng dồn của cả kỳ.",
  loadFailed: "Không đọc được số liệu gói đăng ký.",
  aggregateNote: "cộng mọi app có bảng thuê bao.",
  unmappedBanner: "khách hàng đang dùng gói chưa quy về trục chung.",
  planMappingLink: "Ánh xạ gói",
  emptyTitle: "Chưa có ảnh chụp thuê bao nào.",
  emptyHint: "Chỉ nguồn có khái niệm gói mới xuất hiện ở đây — xem danh sách bên dưới.",
  "col.tier": "Bậc",
  "col.customers": "Khách hàng",
  unmapped: "Chưa ánh xạ",
} as const;
